/**
 * Item #6: chiavi di storage condivise tra web (localStorage) e mobile
 * (SecureStore / AsyncStorage) — single source of truth.
 *
 * ATTENZIONE: i VALORI di queste stringhe sono PERSISTITI sui device e
 * CONDIVISI tra cold-start (wrapper nativo rehydrata il localStorage della PWA
 * con le stesse chiavi) e tra i due client. NON rinominare i valori: cambiarli
 * romperebbe le sessioni esistenti. Questo modulo centralizza solo il literal,
 * non cambia il valore.
 */

/** Chiavi auth/sessione, identiche su web (localStorage) e mobile (SecureStore). */
export const STORAGE_KEYS = {
  /** Access token JWT. */
  ACCESS_TOKEN: 'vvf.access_token',
  /** Refresh token JWT. */
  REFRESH_TOKEN: 'vvf.refresh_token',
  /** Oggetto utente serializzato (JSON). */
  USER: 'vvf.user',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
